import {handleError, httpClient, httpClient2} from '@/api';

// 获取碗碟模型标准例图接口
// 更改: 获取碗碟库所有碗碟
export const _getAllClassList = apiKey => {
  return httpClient
    .get(`class_admin/query`, {
      headers: {
        "api-key": apiKey
      }
    })
    .then(res => {
      console.log("ddddddddddddddddddddd", res);
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(res.data.error_msg);
      }
    });
};
// export const _addClassDishToAll = ({ apiKey, canteenId }) => {
//   return httpClient.post(`salerecord/detail/query/`,
//     {}, {
//       headers: {
//         'api-key': apiKey
//       }
//     }).then(res => {
//     if (res.data.state_code === 0) {
//       return Promise.resolve(res.data.data);
//     } else {
//       return Promise.reject(new Error(`${res.data.error_msg}`));
//     }
//   }).catch(handleError);
// };
export const _imageCollect = ({ dataList, canteenId, machineId }) => {
  console.log("`````````````````````", machineId);
  return httpClient
    .post(`data_collect/`, {
      canteen_id: canteenId,
      data_list: dataList,
      machine_id: machineId
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    })
    .catch(handleError);
};
export const _deleteDishModel = ({ apiKey, canteenId, classId }) => {
  return httpClient
    .post(
      `class_admin/delete/`,
      {
        canteen_id: canteenId,
        class_id: classId
      },
      {
        headers: {
          "api-key": apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    })
    .catch(handleError);
};
export const _addClassDishToCanteen = ({
  apiKey,
  dish_name,
  canteen_id,
  class_id
}) => {
  console.log(class_id);
  return httpClient
    .post(
      `class_admin/canteen/add`,
      {
        dish_name,
        class_id,
        canteen_id
      },
      {
        headers: {
          "api-key": apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(true);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    })
    .catch(handleError);
};
export const _editClassDish = ({
  apiKey,
  class_id,
  canteen_id,
  class_meta_info
}) => {
  return httpClient
    .post(
      `class_admin/edit/`,
      {
        canteen_id,
        class_id,
        class_meta_info
      },
      {
        headers: {
          "api-key": apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(true);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _queryCanteenClassList = ({ apiKey, canteenId }) => {
  return httpClient
    .post(
      `class_admin/canteen/query`,
      { canteen_id: canteenId },
      {
        headers: {
          "api-key": apiKey
        }
      }
    )
    .then(res => {
      console.log(res);
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    })
    .catch(handleError);
};
export const _deleteRelatedClass = ({ apiKey, canteen_id, class_id }) => {
  return httpClient
    .post(
      `class_admin/canteen/delete`,
      {
        class_id,
        canteen_id
      },
      {
        headers: {
          "api-key": apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(true);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};

export const _queryAllCachedDishes = () => {
  return httpClient2.get(`batch/dishadmin/queryAllCachedDishes`).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};

export const _checkPassDishes = canteen_id => {
  console.log(typeof canteen_id);
  return httpClient2
    .post(`batch/dishadmin/passDishes`, {
      canteen_id
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(true);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _checkFailDishes = ({ canteen_id, comment }) => {
  return httpClient2
    .post(`batch/dishadmin/failDishes`, {
      canteen_id,
      comment
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(true);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
// 添加碗碟到碗碟库
export const _addClass = ({
  classify,
  dish_native_name,
  dish_desc,
  dish_img_url,
  dish_type,
  dish_belong,
  apiKey
}) => {
  return httpClient
    .post(
      `/class_admin/add`,
      {
        classify,
        dish_native_name,
        dish_desc,
        dish_img_url,
        dish_type,
        dish_belong
      },
      {
        headers: {
          "api-key": apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _confirmDeleteClass = class_id => {
  return httpClient.post(`/class_admin/delete`, { class_id }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(true);
    } else if (res.data.state_code === -1) {
      return Promise.resolve(false);
    } else {
      return Promise.reject(new Error("错误"));
    }
  });
};

export const _deleteClass = class_id => {
  return httpClient
    .post(`/class_admin/delete_affirm`, { class_id })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _editCanteenClass = ({
  canteen_id,
  class_id,
  dish_name,
  dish_price
}) => {
  return httpClient
    .post(`/class_admin/canteen/edit`, {
      canteen_id,
      class_id,
      dish_name,
      dish_price
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _checkModel = ({
  model_uuid,
  img_url_list = false,
  canteen_id,
  label_task_uuid_list = false
}) => {
  return httpClient
    .post(`/batch_inference`, {
      model_uuid,
      img_url_list,
      canteen_id,
      label_task_uuid_list
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _combineDishes = combineClassId => {
  return httpClient
    .post(`dish_change/new_to_old`, { ...combineClassId })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getImgCountByClassId = class_id => {
  return httpClient
    .post(`get_img_count/by_class_id`, { class_id })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getMarkedImagesByClassId = class_id => {
  return httpClient
    .post(`get_class_img/by_class_id`, { class_id })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getClassDishByClassId = class_id_list => {
  return httpClient
    .post(`class_admin/by_class_id/query`, { class_id_list })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _copyClassDish = (class_id, apiKey) => {
  return httpClient
    .post(
      `class_admin/copy`,
      { class_id },
      {
        headers: {
          "api-key": apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _trainModelCheckResult = task_uuid => {
  console.log(task_uuid);
  return httpClient.post(`batch_inference/result`, { task_uuid }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else if (res.data.state_code) {
      return Promise.reject(new Error("-1"));
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _queryTaskByCanteen = (canteen_id, task_uuid) => {
  return httpClient
    .post(`label_task/query_by_canteen`, {
      canteen_id,
      task_uuid
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
// 通过class_id查询和此碗碟关联的餐厅
export const _getBindCanteenListByClassId = class_id => {
  return httpClient
    .post(`class_admin/canteen_map/query`, { class_id })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};

export const _getAccByCanteen = (canteen_id, day_ts_list) => {
  return httpClient
    .post(`back_data/acc/calculate`, {
      canteen_id,
      day_ts_list
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _classifyQuery = () => {
  return httpClient.get(`classify_query`).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
